import { render, staticRenderFns } from "./ChatPopup.vue?vue&type=template&id=701361a0&"
import script from "./ChatPopup.vue?vue&type=script&lang=js&"
export * from "./ChatPopup.vue?vue&type=script&lang=js&"
import style0 from "./ChatPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports